// ------------------
// Default options
// ------------------

const defaults = {
    mapTypeControl: false,
    streetViewControl: false,
    fullscreenControl: false,
};



// ------------------
// Exports
// ------------------

export default class Map extends google.maps.Map {

    constructor ($el, options) {
        super($el, {...defaults, ...options});
    }

    getView () {
        const center = this.getCenter();
        return {
            lat: center && center.lat(),
            lng: center && center.lng(),
            zoom: this.getZoom()
        }
    }

    convert (coords) {
        const bounds = this.getBounds();
        const projection = this.getProjection();
        const tr = projection.fromLatLngToPoint(bounds.getNorthEast());
        const bl = projection.fromLatLngToPoint(bounds.getSouthWest());
        const scale = Math.pow(2, this.getZoom());
        if (coords.x && coords.y) {
            const point = new google.maps.Point(coords.x / scale + bl.x, coords.y / scale + tr.y);
            return projection.fromPointToLatLng(point);
        }
        if (coords.lat && coords.lng) {
            const point = projection.fromLatLngToPoint(new google.maps.LatLng(coords));
            return new google.maps.Point((point.x - bl.x) * scale, (point.y - tr.y) * scale);
        }
    }


}
